// Same-origin public assets only. Never API/auth/payment/session data.
export async function warmStaticAssets(worker, {extraUrls=[],awaitCompletion=false}={}) {
    if(!('serviceWorker' in navigator))return {status:'unavailable'};
    try {
        worker=worker || navigator.serviceWorker.controller;
        if(!worker && awaitCompletion) {
            const reg=await Promise.race([navigator.serviceWorker.ready,new Promise(resolve=>setTimeout(()=>resolve(null),5000))]);
            worker=reg?.active;
        }
        worker=worker || navigator.serviceWorker.controller;
        if(!worker)return {status:'unavailable'};
        const publicAsset=raw => {
            try {const url=new URL(raw,location.origin);
                return url.origin===location.origin && !/[?&](?:token|auth|signature|key)=/i.test(url.search) &&
                    (/^\/static\/.+\.[a-f0-9]{8,}(?:\.chunk)?\.(?:js|css|png|jpg|webp|svg|woff2?|ttf)$/.test(url.pathname) ||
                    /^\/(?:brands|fonts|game-logos)\/.+\.(?:png|jpg|jpeg|webp|svg|woff2?|ttf)$/.test(url.pathname) || url.pathname==='/logo.png');
            }catch {return false;}
        };
        const urls=[...new Set([...performance.getEntriesByType('resource').map(e=>e.name),...extraUrls])].filter(publicAsset).slice(-64);
        if(!awaitCompletion) {worker.postMessage({type:'CACHE_PUBLIC_ASSETS',urls});return {status:'requested'};}
        return await new Promise(resolve=> {
            const channel=new MessageChannel();
            const timer=setTimeout(()=>done({status:'partial'}),6000);
            function done(value){clearTimeout(timer);channel.port1.close();resolve(value);}
            channel.port1.onmessage=e=>done(e.data?.status ? e.data : {status:'partial'});
            worker.postMessage({type:'CACHE_PUBLIC_ASSETS',urls},[channel.port2]);
        });
    }catch{return {status:'unavailable'};}
}
